import { FilterAdapter, useUrlFilterController } from 'app/components/filters/url-filters';
import Select from 'react-select';
import { AppsFiltersStyles } from 'app/components/common/common-styles';
import { TradeType, DealTypeOption, DEAL_TYPE_OPTIONS } from 'app/console-api/offers/offers';

export const DealTypesAdapter: FilterAdapter<TradeType[]> = {
  key: 'deal_types',
  fromUrl: (sp) => {
    const raw = sp.get('deal_types');
    if (!raw) return null;
    const types = raw
      .split(',')
      .map((s) => s.trim())
      .filter((s): s is TradeType => s === 'exchange' || s === 'buy' || s === 'sell');
    return types.length > 0 ? types : null;
  },
  toUrl: (sp, value) => {
    const next = new URLSearchParams(sp.toString());
    if (!value || value.length === 0) {
      next.delete('deal_types');
    } else {
      next.set('deal_types', value.join(','));
    }
    return next;
  },
  toKey: (v) => `deal_types:${v && v.length ? v.join(',') : 'all'}`
};

type DealTypesFilterProps = Record<string, any>;

export const DealTypesFilter = ({ ...props }: DealTypesFilterProps) => {
  const ctl = useUrlFilterController();
  const value = ctl.get(DealTypesAdapter) ?? [];

  const selected = DEAL_TYPE_OPTIONS.filter((o) => value.includes(o.value));

  return (
    <Select
      styles={AppsFiltersStyles()}
      {...props}
      isMulti
      closeMenuOnSelect={false}
      hideSelectedOptions={false}
      isSearchable={false}
      options={DEAL_TYPE_OPTIONS}
      value={selected}
      placeholder="All deal types"
      onChange={(opts: readonly DealTypeOption[] | null) => {
        const values = (opts ? Array.from(opts) : []).map((o) => o.value);
        ctl.set(DealTypesAdapter, values.length ? values : null);
      }}
    />
  );
};
